const Paragraphs = ({ paragraphs }: any) => (
  <div className="flex-cols space-y-6 max-w-4xl">
    {paragraphs.map((paragraph: any, index: number) => (
      <p key={index}>{paragraph}</p>
    ))}
  </div>
)

export default Paragraphs
